<template>
  <div
    id="import-step-container"
    class="gs-app gm-import-leads pb-6 overflow-y-auto"
    style="
      height: calc(-65px + 100vh);
      background: #f7f6fa;
      scroll-behavior: smooth;
    "
  >
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>
    
    <div class="gm-import-leads__tabs flex w-full text-left mt-2">
      <div class="w-full flex flex-row px-4 justify-center wizard-tabs">
        <gd-tabs
          :tabs="tabs"
          :currentTab="currentTab"
          :disableNotCompleted="true"
          :wrapper-class="'pt-10 pb-6 px-0 gs-default-tabs'"
          :tab-class="mainTabClass"
          :tab-active-class="'gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleTabChange"
        />
      </div>
    </div>
    <div class="w-full flex flex-col relative">
      <div class="gm-import-leads__body flex flex-col p-6">
        <div v-if="currentTab === 'step1'">
          <step1
            ref="step1"
            :model="model"
            @updateModel="model = $event"
            @on-validate="stepValidationSuccessful('step1', $event)"
          ></step1>
        </div>
        <div v-if="currentTab === 'step2'">
          <step2
            ref="step2"
            :model="model"
            @updateModel="model = $event"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
            @on-validate="stepValidationSuccessful('step2', $event)"
          ></step2>
        </div>
        <div v-if="currentTab === 'step3'">
          <step3
            ref="step3"
            :model="model"
            @updateModel="model = $event"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
            @on-validate="stepValidationSuccessful('step3', $event)"
          ></step3>
        </div>
        <div v-if="currentTab === 'step4'">
          <step4
            ref="step4"
            :model="model"
            @updateModel="model = $event"
            @on-validate="stepValidationSuccessful('step4', $event)"
          ></step4>
        </div>
        <div v-if="currentTab === 'step5'">
          <step5
            ref="step5"
            :model="model"
            :lists="lists"
            :tags="tags"
            :existingfield_options="existingfield_options"
            @updateModel="model = $event"
            @openCreateListModal="openCreateListModal"
            @openCreateTagModal="openCreateTagModal"
            @openCreateFieldModal="openCreateFieldModal"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
            @on-validate="stepValidationSuccessful('step5', $event)"
          ></step5>
        </div>
      </div>
    </div>

    <div class="gm-import-leads__actions flex justify-center pb-10">
      <gs-button
        variant="outline"
        size="md"
        class="mr-3"
        v-if="currentTab !== 'step1'"
        @click="moveBackOnWizard()"
      >
        {{ $t('frontend_back') }}</gs-button
      >
      <gs-button
        size="md"
        variant="primary"
        v-if="currentTab !== 'step5'"
        @click="saveAndProceedToNextStep()"
      >
        {{ $t('frontend_next') }}</gs-button
      >
      <gs-button
        size="md"
        variant="primary"
        class="ml-2"
        v-if="currentTab === 'step5'"
        @click="saveAndImportNewLeads()"
      >
        {{ $t('frontend_groovemail_import_leads_save_and_import_btn_text') }}</gs-button
      >
    </div>

    <gd-modal
      name="create-maillist-in-form-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_new_list')"
    >
      <create-list
        :type="'add'"
        :mail_list_id="null"
        :mail_list_data="mail_list_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchEventsList="fetchEventsList"
        @closeCreateMaillistModal="closeCreateMaillist"
      >
      </create-list>
    </gd-modal>

    <gd-modal
      name="create-mailtag-in-form-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_newtag')"
    >
      <create-tag
        :type="'add'"
        :mail_tag_id="null"
        :mail_tag_data="mail_tag_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchTags="fetchEventsTags"
        @closeCreateTagsModal="closeCreateMailtag"
      ></create-tag>
    </gd-modal>

    <gd-modal
      name="add-custom-field-from-leads"
      :title="$t('frontend_groovemail_campains_show_field')"
      class="fieldmodel"
    >
      <create-update-field
        type="add"
        :customfieldData="null"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchfields="fetchandAssignCustomFields"
        @closeCreateFieldModal="closeCreateFieldModal"
      >
      </create-update-field>
    </gd-modal>

    <portal to="headerContent">
      <div class="flex flex-row">
        <gs-button
          variant="outline"
          size="md"
          class="mr-3"
          v-if="currentTab !== 'step1'"
          @click="moveBackOnWizard()"
        >
          {{ $t('frontend_back') }}</gs-button
        >
        <gs-button
          size="md"
          variant="primary"
          v-if="currentTab !== 'step5'"
          @click="saveAndProceedToNextStep()"
        >
          {{ $t('frontend_next') }}</gs-button
        >
        <gs-button
          size="md"
          variant="primary"
          class="ml-2"
          v-if="currentTab === 'step5'"
          @click="saveAndImportNewLeads()"
        >
          {{ $t('frontend_groovemail_import_leads_save_and_import_btn_text') }}</gs-button
        >
      </div>
    </portal>
    <portal to="headerBreadCrumb">
      <div
        class="flex h-full items-center cursor-pointer text-grey-500 hover:text-primary"
        @click="moveBackToLeadsListing"
      >
        <ExitIcon class="w-5 h-5"/>
      </div>
    </portal>
  </div>
</template>

<script>
import axios from 'axios';

import Mailtag from '@/models/Mailtag';
import Customfield from '@/models/Customfield';

import showAlert from '@/components/sweet-alert-popup.js';
import CreateList from '@/components/create-lists.vue';
import CreateTag from '@/components/create-tags.vue';
import CreateUpdateField from '../customfields/create-update-field.vue';

import themeConfig from '@/theme/themeConfig.js';

import step1 from './import-step1';
import step2 from './import-step2';
import step3 from './import-step3';
import step4 from './import-step4';
import step5 from './import-step5';

// import icons
import ExitIcon from '@/assets/images/icons/new/exit_arrow_new.svg';

export default {
  middleware: 'auth',
  layout: 'defaultWithoutSidebarLogo',

  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_import_leads_route_page_title'),
    };
  },

  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      postValidationTab: 'step2',
      lists: [],
      tags: [],
      currentTab: 'step1',
      messages: {},
      model: {
        fileId: null,
        recordsSource: '',
        commercialPlatform: '',
        websiteUrls: [],
        euLeadsAgreedToTerms: false,
        euLeadsAgreedToCommunicate: false,
        leadUploadFiles: [],
        leadsLists: [],
        leadsTags: [],
        importedLeadHeaders: [],
      },
      existingfield_options: [
        {
          name: 'Standard Field',
          fields: [
            {
              type: 'textbox',
              placeholder: 'Email',
              id: 'standard1',
              identifier: 'Email',
              mandatory: 1,
              name: 'email',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_first_name'),
              id: 'standard2',
              identifier: 'First Name',
              mandatory: 0,
              name: 'first_name',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_last_name'),
              id: 'standard3',
              identifier: 'Last Name',
              mandatory: 0,
              name: 'last_name',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_address'),
              id: 'standard4',
              identifier: 'Address',
              mandatory: 0,
              name: 'address_1',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_secondary_address'),
              id: 'standard15',
              identifier: 'Secondary Address',
              mandatory: 0,
              name: 'address_2',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_company'),
              id: 'standard5',
              identifier: 'Company',
              mandatory: 0,
              name: 'company',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_country_code'),
              id: 'standard14',
              identifier: 'Country Code',
              mandatory: 0,
              name: 'country_code',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_phone'),
              id: 'standard6',
              identifier: 'Phone',
              mandatory: 1,
              name: 'phone_number',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_city'),
              id: 'standard11',
              identifier: 'City',
              mandatory: 0,
              name: 'city',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_state'),
              id: 'standard7',
              identifier: 'State',
              mandatory: 0,
              name: 'state',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_country'),
              id: 'standard8',
              identifier: 'Country',
              mandatory: 0,
              name: 'country',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_postalcode'),
              id: 'standard9',
              identifier: 'Postalcode',
              mandatory: 0,
              name: 'zip',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'URL',
              id: 'standard10',
              identifier: 'URL',
              mandatory: 0,
              name: 'url',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_tax_number'),
              id: 'standard12',
              identifier: 'Tax Number',
              mandatory: 0,
              name: 'tax_number',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_billing_address'),
              id: 'standard13',
              identifier: 'Billing Address',
              mandatory: 0,
              name: 'billing_address',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Tags',
              id: 'standard50',
              identifier: 'Tags',
              mandatory: 0,
              name: 'tag',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: this.$t('frontend_lists'),
              id: 'standard51',
              identifier: 'Lists',
              mandatory: 1,
              name: 'list',
              fieldtype: 'standard',
            },
          ],
        },
        {
          name: 'Custom Field',
          fields: [],
        },
      ],
      mail_list_data: { name: '', description: '' },
      mail_tag_data: {
        name: '',
        description: '',
        category: [],
        categoryname: '',
      },
      questions: [
        {
          key: 'recordsSource',
          response: '',
          questionLabel: this.$t('frontend_groovemail_leads_import_multiple_leads_question_records_source'),
        },
        {
          key: 'commercialPlatform',
          response: '',
          questionLabel: this.$t('frontend_groovemail_leads_import_multiple_leads_question_commercial_platform'),
        },
        {
          key: 'euLeadsAgreedToTerms',
          response: '',
          questionLabel: this.$t('frontend_groovemail_leads_import_multiple_leads_question_eu_leads_agreed_to_terms'),
        },
        {
          key: 'euLeadsAgreedToCommunicate',
          response: '',
          questionLabel: this.$t('frontend_groovemail_leads_import_multiple_leads_question_eu_leads_agreed_to_communicate'),
        }
      ]
    };
  },

  components: {
    CreateTag,
    CreateList,
    CreateUpdateField,
    step1,
    step2,
    step3,
    step4,
    step5,
    ExitIcon,
  },

  watch: {
    'model.leadsLists': function leadsLists() {
      if (this.model.leadsLists && this.model.leadsLists.length) {
        const listIndex = this.model.leadsLists.findIndex((ele) => {
          return ele.id === 'createListOption1';
        });
        if (listIndex >= 0) {
          this.model.leadsLists.splice(listIndex, 1);
        }
      }
    },

    'model.leadsTags': function leadsTags() {
      if (this.model.leadsTags && this.model.leadsTags.length) {
        const tagIndex = this.model.leadsTags.findIndex((ele) => {
          return ele.id === 'createTagOption1';
        });
        if (tagIndex >= 0) {
          this.model.leadsTags.splice(tagIndex, 1);
        }
      }
    },
  },

  methods: {
    handleTabChange(newTab) {
      if (this.currentTab > newTab) {
        this.currentTab = newTab;
        this.scrollTop();
      }
    },

    moveBackOnWizard() {
      const currentlySelectedTabIndex = this.tabs
        .map((item) => item.value)
        .indexOf(this.currentTab);
      const nextTab = this.tabs[currentlySelectedTabIndex - 1].value;
      this.postValidationTab = nextTab;
      this.currentTab = nextTab;
      this.scrollTop();
    },

    moveBackToLeadsListing() {
      this.$router.push({ name: 'Leads2' }).catch(() => {});
    },

    saveAndProceedToNextStep() {
      const currentlySelectedTabIndex = this.tabs
        .map((item) => item.value)
        .indexOf(this.currentTab);
      const nextTab = this.tabs[currentlySelectedTabIndex + 1].value;
      this.postValidationTab = nextTab;
      const refToValidate = this.$refs[this.currentTab];
      this.scrollTop();
      return refToValidate.validate();
    },

    async saveAndImportNewLeads() {
      const refToValidate = this.$refs[this.currentTab];
      const isLastStepValid = refToValidate.validate();
      if (isLastStepValid) {
        this.showLoader();
        const formDataForImport = this.prepareFormDataForImporting();
        try {
          const uploadRes = await axios.post('/import-leads/file-upload-leads-csv', formDataForImport);
          if (uploadRes.data.status === 200) {
            const swalText = this.messages.data && this.messages.data.import_lead_success
              ? this.messages.data && this.messages.data.import_lead_success
              : this.$t('frontend_groovemail_leads_import_multiple_leads_pending_message');
            showAlert({
              iconType: 'alert-success',
              html : `<p class="text-sm text-deep-dark"> ${ swalText }</p>`,
              showCancelButton: false,
              showCloseButton: true,
              confirmButtonColor: '#2f80ed',
              confirmButtonText: this.$t(
                'frontend_close'
              ),
            });
            this.hideLoader();
            this.moveBackToLeadsListing();
          } else if (uploadRes.data.status === 402 || uploadRes.data.status === 406) {
            showAlert({
              iconType: 'alert-error',
              html : `
                <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
                <p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_leads_import_multiple_leads_importing_failed') }</p>
              `,
              showCancelButton: false,
              showCloseButton: true,
              confirmButtonColor: themeConfig.appPrimaryColor,
              confirmButtonText: this.$t(
                'frontend_close'
              ),
            });
            this.hideLoader();
          }
        } catch (e) {
          this.hideLoader();
        }
      }
    },

    /**
     * Prepares form data for importing leads.
     * Creates a new FormData object and appends the necessary properties to it.
     * Returns the FormData object.
     * @returns {FormData} - The FormData object containing the lead import data.
    */
    prepareFormDataForImporting() {
      const formData = new FormData();
      formData.append('id', this.model.fileId);
      formData.append('lists',
        this.model.leadsLists && this.model.leadsLists.length
          ? JSON.stringify(this.model.leadsLists)
          : '[]'
      );
      formData.append(
        'tags',
        this.model.leadsTags && this.model.leadsTags.length
          ? JSON.stringify(this.model.leadsTags)
          : '[]'
      );
      let mappingIndex = 0;
      this.model.importedLeadHeaders.map((ele) => {
        if (!ele.key) {
          this.model.importedLeadHeaders[mappingIndex].key = null;
          this.model.importedLeadHeaders[mappingIndex].type = "";
        }
        mappingIndex += 1;
      });
      const actualMappings = this.model.importedLeadHeaders.filter((ele) => {
        if (ele.key) {
          return ele;
        }
      });
      formData.append(
        'mappings',
        actualMappings && actualMappings.length ? JSON.stringify(actualMappings) : '[]'
      );
      formData.append(
        'all_mapping',
        this.model.importedLeadHeaders && this.model.importedLeadHeaders.length ? JSON.stringify(this.model.importedLeadHeaders) : '[]'
      );
      for (let element = 0; element < this.questions.length; element += 1) {
        if (
          this.questions[element].key === 'euLeadsAgreedToCommunicate' ||
          this.questions[element].key === 'euLeadsAgreedToTerms'
        ) {
          this.questions[element].response = this.model[this.questions[element].key] === true ? 'yes' : 'no';
        } else {
          this.questions[element].response = this.model[this.questions[element].key];
        }
      }
      formData.append(
        'questions',
        this.questions && this.questions.length ? JSON.stringify(this.questions) : '[]'
      );
      this.model.websiteUrls.forEach((webEle) => {
        delete webEle.verifyOtp;
        delete webEle.sendDisabled;
        delete webEle.verificationSendMailCount;
        webEle.email = `${webEle.email}@${webEle.domain}`;
      });
      formData.append(
        'website_urls',
        this.model.websiteUrls && this.model.websiteUrls.length ?
          JSON.stringify(this.model.websiteUrls) : '[]'
      );

      return formData;
    },

    async stepValidationSuccessful(name, isValid) {
      if (isValid && name !== 'step5') {
        this.currentTab = this.postValidationTab;
      }
    },

    async fetchandAssignCustomFields() {
      const customfieldsData = await Customfield.$get();
      const customfields = [];
      for (let i = 0; i < customfieldsData.length; i += 1) {
        if (
          customfieldsData[i].type === 'textarea' ||
          customfieldsData[i].type === 'textbox'
        ) {
          customfields.push({
            id: customfieldsData[i].id,
            type: customfieldsData[i].type,
            placeholder: customfieldsData[i].fieldplaceholder,
            mandatory: customfieldsData[i].mandatory,
            identifier: customfieldsData[i].identifier,
            fieldtype: 'custom',
          });
        } else {
          const options =
            customfieldsData[i].fieldoptions !== '' ||
            customfieldsData[i].fieldoptions != null
              ? JSON.parse(customfieldsData[i].fieldoptions)
              : [];
          customfields.push({
            id: customfieldsData[i].id,
            type: customfieldsData[i].type,
            fieldlabel: customfieldsData[i].fieldlabel,
            options,
            identifier: customfieldsData[i].identifier,
            mandatory: customfieldsData[i].mandatory,
            fieldtype: 'custom',
          });
        }
      }
      this.existingfield_options[1].fields = customfields;
    },

    openCreateFieldModal() {
      this.$root.$emit('modal-open', 'add-custom-field-from-leads');
    },

    closeCreateFieldModal() {
      this.$root.$emit('modal-close', 'add-custom-field-from-leads');
    },

    openCreateListModal() {
      this.mail_list_data.name = '';
      this.mail_list_data.description = '';
      this.$root.$emit('modal-open', 'create-maillist-in-form-modal');
    },

    async fetchEventsList(listData) {
      const mailLists = await axios.get(`/maillistonly`);
      this.lists = mailLists?.data?.data;
      if (listData && listData.data && listData.data.id) {
        this.model.leadsLists.push({
          id: listData.data.id,
          name: listData.data.name,
        });
      }
    },

    closeCreateMaillist() {
      this.$root.$emit('modal-close', 'create-maillist-in-form-modal');
    },

    openCreateTagModal() {
      this.mail_tag_data.name = '';
      this.mail_tag_data.description = '';
      this.mail_tag_data.category = [];
      this.mail_tag_data.categoryname = '';
      this.$root.$emit('modal-open', 'create-mailtag-in-form-modal');
    },

    async fetchEventsTags(tagData) {
      this.tags = await Mailtag.$get();
      if (tagData && tagData.data && tagData.data.id) {
        this.model.leadsTags.push({
          id: tagData.data.id,
          name: tagData.data.name,
        });
      }
    },

    closeCreateMailtag() {
      this.$root.$emit('modal-close', 'create-mailtag-in-form-modal');
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // scroll top function
    scrollTop() {
      document.getElementById('import-step-container').scrollTop = 0;
    },
  },

  computed: {
    tabs() {
      return [
        {
          title: `<span class="text-sm font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_leads_import_step_1_record_info'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step1',
        },
        {
          title: `<span class="text-sm font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_leads_import_step_2_website_url'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step2',
        },
        {
          title: `<span class="text-sm font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_leads_import_step_3_confirm_website_ownership'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step3',
        },
        {
          title: `<span class="text-sm font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_leads_import_step_4_gdpr_regulations'
            )} <i class="mr-2 ml-1 text-xs fas fa-chevron-right" aria-hidden="true"></i><span>`,
          value: 'step4',
        },
        {
          title: `<span class="text-sm font-semibold"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            ${this.$t(
              'frontend_groovemail_leads_import_step_5_lists_tags_import_leads'
            )}<span>`,
          value: 'step5',
        },
      ];
    },

    mainTabClass() {
      if (this.currentTab === 'step1') {
        return 'pb-2 gs-default-tabs-item';
      }
        return 'pb-2 gs-default-tabs-item';
    },
  },

  async created() {
    const mailLists = await axios.get(`/maillistonly`);
    this.lists = mailLists?.data?.data;
    this.tags = await Mailtag.$get();
    this.messages = await axios.get('/get-default-messages');
    this.fetchandAssignCustomFields();
  },
};
</script>

<style lang="scss">
.wizard-tabs .tabs .tabs__item:nth-last-child(2) span.text-sm:before {
  content: none !important;
}
</style>

<style scoped>
.gm-import-leads__tabs,
.gm-import-leads__body,
.gm-import-leads__actions {
  min-width: 0;
}

.gm-import-leads__body {
  max-width: 1120px;
  margin-right: auto;
  margin-left: auto;
}

@media (max-width: 640px) {
  .gm-import-leads__tabs {
    overflow-x: auto;
  }

  .gm-import-leads__body {
    padding: 20px 18px;
  }

  .gm-import-leads__actions {
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding-right: 18px;
    padding-left: 18px;
  }

  .gm-import-leads__actions > button {
    max-width: 100%;
  }
}
</style>
